<div class="container-fluid">
  <div class="mct-flex mct-row mb-3">
    <h3 class="m-0">
      {{ 'events.settings.registration-fields.title' | translate | titlecase }}
      <a
        href="https://support.weblinkinternational.com/hc/en-us/articles/235638968-Event-Settings-Registration-Fields"
        target="_blank"
        class="ml-2"
      >
        <i
          class="pi pi-question-circle wc-help-icon"
          [title]="'events.settings.registration-fields.registration-fields-title-help' | translate"
        ></i>
      </a>
    </h3>
  </div>

  <div class="mb-5">
    <div class="p-20">
      <div class="row font-weight-bold small text-muted text-uppercase">
        <div class="col-xs-offset-3 col-sm-offset-4 col-md-offset-3 col-xs-4 col-md-1 text-center">{{ 'common.visible' | translate }}</div>
        <div class="col-xs-4 col-md-1 text-center">{{ 'common.required' | translate }}</div>
      </div>
    </div>

    <div class="list-group list-group-flush">
      <div class="list-group-item">
        <wl-event-v4-settings-registration-fields-field-row
          [displayName]="'common.personal-information.email-address' | translate | titlecase"
          [(visibilityFieldValue)]="event.RegEmailVisible"
          [(requiredFieldValue)]="event.RegEmailRequired"
          [registrationRequiredDisabled]="true"
          [registrationVisibleDisabled]="true"
        >
        </wl-event-v4-settings-registration-fields-field-row>
      </div>

      <div
        class="list-group-item"
        *ngFor="
          let field of [
            { label: 'common.personal-information.prefix', vis: 'RegPrefixVisible', req: 'RegPrefixRequired' },
            { label: 'common.personal-information.first-name', vis: 'RegFNameVisible', req: 'RegFNameRequired' },
            { label: 'common.personal-information.last-name', vis: 'RegLNameVisible', req: 'RegLNameRequired' },
            { label: 'common.personal-information.company-name', vis: 'RegCompanyNameVisible', req: 'RegCompanyNameRequired' },
            { label: 'common.personal-information.title', vis: 'RegTitleVisible', req: 'RegTitleRequired' },
            { label: 'common.personal-information.address', vis: 'RegAddressVisible', req: 'RegAddressRequired' },
            { label: 'common.personal-information.phone', vis: 'RegPhoneVisible', req: 'RegPhoneRequired' },
          ]
        "
      >
        <wl-event-v4-settings-registration-fields-field-row
          [displayName]="field.label | translate | titlecase"
          [(visibilityFieldValue)]="event[field.vis]"
          [(requiredFieldValue)]="event[field.req]"
        >
        </wl-event-v4-settings-registration-fields-field-row>
      </div>

      <div class="list-group-item">
        <wl-event-v4-settings-registration-fields-field-row
          [displayName]="'events.settings.registration-fields.name-for-badge' | translate | titlecase"
          [(visibilityFieldValue)]="event.RegNameForBadgeVisible"
          [(requiredFieldValue)]="event.RegNameForBadgeRequired"
          [regVisibleFieldVisible]="false"
          [regRequiredVisible]="false"
        >
        </wl-event-v4-settings-registration-fields-field-row>
      </div>
    </div>
  </div>

  <div class="mct-flex mct-row mb-10 mt-10 mct-gap-10">
    <h3 class="m-0">{{ 'events.settings.registration-fields.custom-reg-fields-title' | translate | titlecase }}</h3>
    <button
      pButton
      class="atlas-btn atlas-btn-primary"
      [disabled]="userAccessLevel < 2"
      icon="pi pi-plus"
      [label]="'events.settings.registration-fields.add-custom-field-label' | translate | titlecase"
      (click)="newCustomRegField()"
    ></button>
  </div>

  <div [hidden]="!loadingCustomRegFields.busy" class="text-center py-4">
    <wl-busy [show]="loadingCustomRegFields.busy"></wl-busy>
  </div>

  <div class="alert alert-danger" *ngIf="loadingCustomRegFields.message && !loadingCustomRegFields.success">
    <i class="pi pi-exclamation-triangle mr-2"></i> {{ loadingCustomRegFields.message }}
  </div>

  <div class="mb-10" *ngIf="!loadingCustomRegFields.busy && customRegFields?.length">
    <table class="table mb-0">
      <thead class="bg-light">
        <tr>
          <th style="width: 40px"></th>
          <th style="width: 80px">{{ 'events.settings.registration-fields.field-id-label' | translate | titlecase }}</th>
          <th>{{ 'events.settings.registration-fields.field-name-label' | translate | titlecase }}</th>
          <th>{{ 'events.settings.registration-fields.field-type-label' | translate | titlecase }}</th>
          <th class="text-right" style="width: 200px"></th>
        </tr>
      </thead>
      <tbody cdkDropList (cdkDropListDropped)="handleCustomFieldSortDrop($event)">
        <tr *ngFor="let customField of customRegFields; let i = index" cdkDrag class="wc-movable-row">
          <td class="text-muted cursor-move" cdkDragHandle>
            <i class="pi pi-bars"></i>
          </td>
          <td class="text-muted small">#{{ customField.Id }}</td>
          <td class="font-weight-bold">{{ customField.FieldName }}</td>
          <td>
            <span class="py-1 px-2 font-weight-normal">
              {{
                customField.UiControlType
                  ? ('enum.eventcustomregfielduicontroltype.' + customField.UiControlType.toLowerCase() | translate | titlecase)
                  : ('common.none' | translate)
              }}
            </span>
          </td>
          <td class="text-right">
            <button
              pButton
              type="button"
              icon="pi pi-pencil"
              class="atlas-btn atlas-btn-default p-button-text p-button-sm"
              [label]="'common.edit' | translate | uppercase"
              (click)="editCustomRegField(customField.Id)"
              [disabled]="userAccessLevel < 2"
            ></button>
            <button
              pButton
              type="button"
              icon="pi pi-trash"
              class="atlas-btn atlas-btn-danger p-button-text p-button-sm"
              (click)="confirmDeleteCustomRegField(customField.Id, i)"
              [label]="'common.delete' | translate | uppercase"
              [disabled]="userAccessLevel < 2"
            ></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-back-to-top></app-back-to-top>
</div>

<p-dialog
  #customRegFieldsEditModal
  modal="true"
  [(visible)]="showModal"
  [closable]="true"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
  baseZIndex="3"
>
  <ng-template #header>
    <h4 class="modal-title">
      {{ 'events.settings.registration-fields.custom-reg-fields-title' | translate | titlecase }}
    </h4>
  </ng-template>

  <div class="container-fluid pt-2">
    <div [hidden]="!loadingCustomRegField.busy" class="text-center py-5">
      <wl-busy [show]="loadingCustomRegField.busy"></wl-busy>
    </div>

    <form
      id="customFieldEditForm"
      #customFieldEditForm="ngForm"
      class="form-horizontal"
      *ngIf="!loadingCustomRegField.busy && loadingCustomRegField.success"
    >
      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.registration-fields.field-name-label' | translate | titlecase }}*</label>
        <div class="col-sm-9">
          <input class="form-control" type="text" name="fieldName" [(ngModel)]="eventCustomRegField.FieldName" required />
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.registration-fields.description-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <textarea class="form-control" rows="2" name="fieldDescr" [(ngModel)]="eventCustomRegField.Descr"></textarea>
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-offset-3 col-md-offset-2 col-sm-9">
          <div class="row">
            <div class="col-xs-offset-3 col-md-offset-2 col-xs-4 col-md-1 text-center">
              {{ 'common.visible' | translate | titlecase }}
            </div>
            <div class="col-xs-4 col-md-1 text-center">
              {{ 'common.required' | translate | titlecase }}
            </div>
          </div>
          <wl-event-v4-settings-registration-fields-field-row
            offsetClass=""
            [(visibilityFieldValue)]="eventCustomRegField.Visible"
            [(requiredFieldValue)]="eventCustomRegField.Required"
          >
          </wl-event-v4-settings-registration-fields-field-row>
          <div class="text-danger mt-2 small" *ngIf="eventCustomRegField.Visible == 0">
            <i class="pi pi-exclamation-circle mr-1"></i>
            {{ 'events.settings.registration-fields.custom-not-both-visible-error' | translate }}
          </div>
        </div>
      </div>

      <div class="form-group mt-4">
        <label for="fieldStaffOnly" class="col-sm-3 text-right">{{
          'events.settings.registration-fields.staff-only-label' | translate | titlecase
        }}</label>
        <div class="col-sm-9">
          <p-checkbox binary="true" name="fieldStaffOnly" id="fieldStaffOnly" [(ngModel)]="eventCustomRegField.StaffOnly"></p-checkbox>
        </div>
      </div>

      <div class="form-group mt-4">
        <label class="col-sm-3 control-label">{{ 'events.settings.registration-fields.applies-to-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <div *ngFor="let item of eventItems; let idx = index" class="mb-2">
            <p-checkbox binary="true" [name]="'fieldApply-' + idx" [id]="'fieldApply-' + idx" [(ngModel)]="item.apply"></p-checkbox>
            <label [for]="'fieldApply-' + idx" class="ml-2">{{ item.eventItemName }}</label>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.registration-fields.field-type-label' | translate | titlecase }}*</label>
        <div class="col-sm-9">
          <p-select
            [options]="uiControlTypes"
            name="fieldUIControlType"
            [(ngModel)]="eventCustomRegField.UiControlType"
            optionLabel="display"
            optionValue="value"
            styleClass="w-100"
            [required]="true"
            [placeholder]="'common.select' | translate"
            appendTo="body"
          >
            <ng-template let-option #item>
              {{ option.display | translate | titlecase }}
            </ng-template>

            <ng-template let-option #selectedItem>
              {{ option?.display | translate | titlecase }}
            </ng-template>
          </p-select>
        </div>
      </div>

      <div class="form-group mt-4" *ngIf="eventCustomRegField.UiControlType == 'DropdownList'">
        <label class="col-sm-3 control-label">{{
          'events.settings.registration-fields.available-values-label' | translate | titlecase
        }}</label>
        <div class="col-sm-9">
          <div class="mb-4">
            <button
              pButton
              class="atlas-btn atlas-btn-primary p-button-text p-button-sm"
              [disabled]="userAccessLevel < 2"
              icon="pi pi-plus"
              [label]="'events.settings.registration-fields.available-value' | translate | titlecase"
              (click)="addAvailableValue()"
            ></button>
          </div>
          <div class="alert alert-info" *ngIf="!eventCustomRegField.AvailableValues.length">
            {{ 'events.settings.registration-fields.available-values-placeholder' | translate }}
          </div>
          <ul class="list-unstyled">
            <li
              class="wc-available-value-box p-3 border rounded mb-3 bg-white shadow-sm"
              [ngClass]="{ 'wc-available-value-highlight': val._highlight }"
              *ngFor="let val of eventCustomRegField.AvailableValues; let i = index"
            >
              <div class="mct-flex mct-row mct-gap-5 mb-2">
                <span>Option #{{ i + 1 }}</span>
                <div class="btn-group mct-flex mct-row mct-gap-5">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrow-up"
                    class="atlas-btn atlas-btn-secondary p-button-text p-button-sm"
                    [disabled]="!i"
                    (click)="handleAvailableValueMoveUp(i)"
                  ></button>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-arrow-down"
                    class="atlas-btn atlas-btn-secondary p-button-text p-button-sm"
                    [disabled]="i == eventCustomRegField.AvailableValues.length - 1"
                    (click)="handleAvailableValueMoveDown(i)"
                  ></button>
                </div>
              </div>

              <wl-event-v4-settings-registration-field-drop-down-values
                [(availableValue)]="eventCustomRegField.AvailableValues[i]"
                (remove)="removeAvailableValue(i)"
              >
              </wl-event-v4-settings-registration-field-drop-down-values>

              <div class="mt-3 pt-2 border-top">
                <wl-event-v4-registration-field-drop-down-value-credit-type-list [availValueCreditTypes]="val.CreditTypes">
                </wl-event-v4-registration-field-drop-down-value-credit-type-list>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="form-group mt-4" *ngIf="totalAdditionalCost > 0">
        <label class="col-sm-3 control-label">{{ 'events.settings.registration-fields.revenue-item-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <wl-revenue-item-selector name="fieldItemNum" [(ngModel)]="eventCustomRegField.ItemNum" required></wl-revenue-item-selector>
        </div>
      </div>
      <div class="form-group mt-4" *ngIf="totalAdditionalCost > 0">
        <label class="col-sm-3 control-label">{{ 'events.settings.registration-fields.payment-type-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <wl-payment-type-selector
            name="fieldPaymentType"
            [(ngModel)]="eventCustomRegField.PaymentTypeID"
            [(revenueItemNum)]="eventCustomRegField.ItemNum"
            [creditCardType]="true"
            required
          >
          </wl-payment-type-selector>
        </div>
      </div>
    </form>
  </div>

  <ng-template #footer>
    <div [hidden]="loadingCustomRegField.busy">
      <div class="alert alert-danger text-left" *ngIf="customFieldSaveError">
        {{ customFieldSaveError }}
      </div>
      <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-10">
        <wl-busy [show]="customFieldSaving"></wl-busy>
        <button
          pButton
          name="saveCustomRegFields"
          id="saveCustomRegFields"
          type="button"
          class="atlas-btn atlas-btn-primary"
          (click)="saveCustomRegFields()"
          [disabled]="customFieldSaving || eventCustomRegField.Visible == 0"
          icon="pi pi-save"
          [label]="(customFieldSaving ? 'common.saving' : 'common.save') | translate | titlecase"
        ></button>
        <button
          pButton
          type="button"
          name="cancelCustomRegFields"
          id="cancelCustomRegFields"
          class="atlas-btn atlas-btn-secondary"
          (click)="showModal = false"
          [disabled]="customFieldSaving"
          icon="pi pi-ban"
          [label]="'common.cancel' | translate | titlecase"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
